import React from 'react';
import { Accordion, Button } from 'flowbite-react';
import { UISupportQuestion } from 'types';
import QuestionVoteButtons from './QuestionVoteButtons';

interface SupportModalQuestionsAccordionProps {
    questions: UISupportQuestion[];
    onRaiseTicket: (questionId?: string) => void;
    onVote: (questionId: string, question: string, voteType: import('types').VoteType) => void;
    voteLoading: boolean;
}

const ACCORDION_BORDER_STYLES = `
.support-modal-accordion-wrapper .accordion,
.support-modal-accordion-wrapper .accordion *,
.support-modal-accordion-wrapper [class*="accordion"],
.support-modal-accordion-wrapper [class*="accordion"] *,
.support-modal-accordion-wrapper button[class*="accordion"],
.support-modal-accordion-wrapper [data-accordion],
.support-modal-accordion-wrapper [id*="accordion"] {
    border-width: 0 !important;
    border-style: none !important;
    border-color: transparent !important;
    box-shadow: none !important;
}
.support-modal-accordion-wrapper * {
    border-top-width: 0 !important;
    border-bottom-width: 0 !important;
    border-left-width: 0 !important;
    border-right-width: 0 !important;
}
`;

const SupportModalQuestionsAccordion: React.FC<SupportModalQuestionsAccordionProps> = ({
    questions,
    onRaiseTicket,
    onVote,
    voteLoading,
}) => (
    <div className="support-modal-accordion-wrapper space-y-0 min-w-0">
        <style>{ACCORDION_BORDER_STYLES}</style>
        <Accordion collapseAll className="[&_.accordion]:!border-0 [&_.accordion>*]:!border-0 [&_.accordion>*]:!border-t-0">
            {[
                ...questions.map((question: UISupportQuestion) => (
                    <Accordion.Panel key={question._id} className="!border-0 !border-t-0 !border-b-0 !border-l-0 !border-r-0">
                        <Accordion.Title className="text-gray-900 dark:text-white !border-0 !border-t-0 !border-b-0 !border-l-0 !border-r-0 border-none focus:ring-0">
                            {question.question}
                        </Accordion.Title>
                        <Accordion.Content className="!border-0 !border-t-0 !border-b-0 !border-l-0 !border-r-0">
                            {question.answer ? (
                                <div className="space-y-4">
                                    <div className="bg-blue-50 dark:bg-blue-900 p-4 rounded-lg">
                                        <p className="text-gray-700 dark:text-gray-300 whitespace-pre-wrap">
                                            {question.answer}
                                        </p>
                                    </div>
                                    <QuestionVoteButtons
                                        questionId={question._id}
                                        question={question.question}
                                        onVote={onVote}
                                        isLoading={voteLoading}
                                        renderExtra={({ downvotes }) =>
                                            downvotes > 0 ? (
                                                <Button
                                                    color="purplePlaced"
                                                    onClick={() => onRaiseTicket(question._id)}
                                                    className="w-full"
                                                >
                                                    Raise a Support Ticket
                                                </Button>
                                            ) : null
                                        }
                                    />
                                </div>
                            ) : (
                                <Button
                                    color="purplePlaced"
                                    onClick={() => onRaiseTicket(question._id)}
                                    className="w-full"
                                >
                                    Raise a Support Ticket
                                </Button>
                            )}
                        </Accordion.Content>
                    </Accordion.Panel>
                )),
                <Accordion.Panel key="didnt-find" className="!border-0 !border-t-0 !border-b-0 !border-l-0 !border-r-0">
                    <Accordion.Title className="text-gray-700 dark:text-gray-300 !border-0 !border-t-0 !border-b-0 !border-l-0 !border-r-0 border-none focus:ring-0">
                        Didn't find your question?
                    </Accordion.Title>
                    <Accordion.Content className="!border-0 !border-t-0 !border-b-0 !border-l-0 !border-r-0">
                        <div className="space-y-4">
                            <p className="text-gray-600 dark:text-gray-400">
                                If you couldn't find the answer you're looking for, you can raise a support ticket and our team will assist you.
                            </p>
                            <Button
                                color="purplePlaced"
                                onClick={() => onRaiseTicket()}
                                className="w-full"
                            >
                                Raise a Support Ticket
                            </Button>
                        </div>
                    </Accordion.Content>
                </Accordion.Panel>,
            ] as React.ReactElement<any>[]}
        </Accordion>
    </div>
);

export default SupportModalQuestionsAccordion;
